
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","stroke":"#4A4A4A"}},[_c('g',{attrs:{"transform":"translate(1 3)","stroke-width":".5"}},[_c('path',{attrs:{"d":"M7.26 6.647c.53 1.247.71 2.453.543 3.618-1.736.675-3.036 1.013-3.9 1.013-.865 0-2.166-.338-3.903-1.013.002-1.694.155-2.9.46-3.618.456-1.078 6.007-1.872 6.8 0z"}}),_c('ellipse',{attrs:{"cx":"3.628","cy":"2.991","rx":"3.023","ry":"2.991"}})]),_c('g',{attrs:{"transform":"translate(11 3)","stroke-width":".5"}},[_c('path',{attrs:{"d":"M7.26 6.647c.53 1.247.71 2.453.543 3.618-1.736.675-3.036 1.013-3.9 1.013-.865 0-2.166-.338-3.903-1.013.002-1.694.155-2.9.46-3.618.456-1.078 6.007-1.872 6.8 0z"}}),_c('ellipse',{attrs:{"cx":"3.628","cy":"2.991","rx":"3.023","ry":"2.991"}})]),_c('path',{attrs:{"d":"M14.801 12.271c.714 1.604.958 3.155.733 4.652-2.343.868-4.098 1.302-5.266 1.302-1.167 0-2.923-.434-5.268-1.302.003-2.178.21-3.728.62-4.652.617-1.385 8.11-2.406 9.181 0z"}}),_c('ellipse',{attrs:{"cx":"10.082","cy":"7.846","rx":"4.082","ry":"3.846"}})])])
          )
        }
      }
    